import React, { useContext } from 'react';
import { ReactComponent as Sun } from "./img/Sun.svg";
import { ReactComponent as Moon } from "./img/Moon.svg";
import "./DarkMode.css";
import { ThemeContext } from './context/ThemeContext';

const DarkMode = () => {

    const { darkMode, setDarkMode } = useContext(ThemeContext)

    const handleTheme = () => {
        setDarkMode(!darkMode);
        localStorage.setItem('darkMode', !darkMode)
    }
    
    return (
        <div className='dark_mode'>
            <input onClick={handleTheme}
                className='dark_mode_input'
                type='checkbox'
                id='darkmode-toggle'
                checked={darkMode}
                onChange={() => {}}
            />
            <label className='dark_mode_label' htmlFor='darkmode-toggle'>
                <Sun />
                <Moon />
            </label>
        </div>
    );
};

export default DarkMode;
